import { c as _c } from "react/compiler-runtime";
import { ListItemCardMobile } from "@components/common/mobile/list-item-card-mobile";
import { useTeamMenuOptions } from "@pages/members/teams/use-team-menu-options";
import { useAppSelector } from "@store/store-helper";
import { selectedEntitiesSelector } from "@store/table/table-selector";
import { selectedSdbCompanySelector } from "@store/sdb-company/sdb-company-selector";
import { VirtualizedGrid } from "@components/virtualized/virtualized-grid";
import { Box, Stack } from "@mui-wrapper";
import { generateTeamDetailsRoute } from "@router/router-helper";
import { FaroTableBulkActions } from "@components/common/faro-table/faro-table-bulk-actions";
import { useTeamsPageBulkActions } from "@pages/members/teams/use-teams-page-bulk-actions";
import { formatUserRoleType, nounPluralize } from "@utils/data-display";
import { useDateTime } from "@hooks/use-date-time";
import { NO_TRANSLATE_CLASS, TeamIcon } from "@flat-ui";
import { SphereAvatar } from "@components/header/sphere-avatar";
import { teamDisplayProperties } from "@components/table/teams/teams-table-utils";
import { useMemo } from "react";
import { SkeletonMemberListItemCard } from "@components/common/mobile/skeleton-member-list-item-card";
/**
 * Mobile-specific view for teams list with action bar and card layout.
 */
export function TeamsMobileView(t0) {
  const $ = _c(28);
  const {
    teams,
    isLoading,
    sortBy,
    shouldExcludeRemove,
    memberToRemove,
    shouldConfirmTeamRoleChange
  } = t0;
  let t1;
  if ($[0] !== memberToRemove || $[1] !== shouldConfirmTeamRoleChange || $[2] !== shouldExcludeRemove) {
    t1 = {
      shouldExcludeRemove,
      memberToRemove,
      shouldConfirmTeamRoleChange
    };
    $[0] = memberToRemove;
    $[1] = shouldConfirmTeamRoleChange;
    $[2] = shouldExcludeRemove;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const menuItems = useTeamMenuOptions(t1);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = selectedEntitiesSelector("teams");
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const selectedEntities = useAppSelector(t2);
  const selectedSdbCompany = useAppSelector(selectedSdbCompanySelector);
  const {
    formatDate
  } = useDateTime();
  let t3;
  if ($[5] !== teams) {
    t3 = teams.map(_temp);
    $[5] = teams;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const allTeamIds = t3;
  const t4 = selectedSdbCompany?.id ?? "";
  let t5;
  if ($[7] !== shouldExcludeRemove || $[8] !== t4 || $[9] !== teams) {
    t5 = {
      companyId: t4,
      teams,
      shouldExcludeRemove
    };
    $[7] = shouldExcludeRemove;
    $[8] = t4;
    $[9] = teams;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const bulkActionsButtons = useTeamsPageBulkActions(t5);
  if (!selectedSdbCompany) {
    return null;
  }
  let t6;
  if ($[11] !== formatDate || $[12] !== menuItems || $[13] !== selectedSdbCompany.id) {
    t6 = team_0 => {
      const creationDate = formatDate(team_0.createdAt);
      const role = formatUserRoleType(team_0.role);
      const membersCount = nounPluralize({
        counter: team_0.memberCount,
        word: "member"
      });
      const secondaryText = `${role} • ${membersCount}`;
      return <Box key={team_0.id}><ListItemCardMobile item={team_0} image={<Stack sx={{
          justifyContent: "center"
        }}><SphereAvatar icon={<TeamIcon sx={{
            width: "20px",
            height: "20px"
          }} />} size="small" shouldHideWhiteRim={true} backgroundColor={teamDisplayProperties[team_0.category.kind].color} /></Stack>} title={<span className={NO_TRANSLATE_CLASS}>{team_0.name}</span>} href={generateTeamDetailsRoute(selectedSdbCompany.id, team_0.id)} subtitle={`Created: ${creationDate}`} secondaryText={secondaryText} menuItems={menuItems} /></Box>;
    };
    $[11] = formatDate;
    $[12] = menuItems;
    $[13] = selectedSdbCompany.id;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== isLoading || $[16] !== sortBy || $[17] !== t6 || $[18] !== teams) {
    t7 = <VirtualizedGrid key={sortBy} items={teams} isLoading={isLoading} renderSkeletonItem={_temp2} estimateSize={112} shouldMeasureRowHeight={true} renderItem={t6} />;
    $[15] = isLoading;
    $[16] = sortBy;
    $[17] = t6;
    $[18] = teams;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== allTeamIds || $[21] !== bulkActionsButtons || $[22] !== isLoading || $[23] !== selectedEntities.length) {
    t8 = <FaroTableBulkActions bulkActionsButtons={bulkActionsButtons} numberOfSelectedRows={selectedEntities.length} isLoading={isLoading} allRowIds={allTeamIds} />;
    $[20] = allTeamIds;
    $[21] = bulkActionsButtons;
    $[22] = isLoading;
    $[23] = selectedEntities.length;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t7 || $[26] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
}
function _temp2(index) {
  return <Box key={index}><SkeletonMemberListItemCard /></Box>;
}
function _temp(team) {
  return team.id;
}